import {
	BsSearch,
	BsEnvelope,
	BsEnvelopePaper,
	BsGear,
	BsBuilding,
	BsDiagram3,
	BsFileText,
	BsGlobe2,
	BsList,
	BsListCheck,
	BsMap,
	BsPencilSquare,
	BsQuestionCircle,
	BsKanban,
	BsShieldLock,
	BsTrash,
	BsBox,
	BsCalendarEvent,
	BsHouse,
} from 'react-icons/bs';

const navItems = [
	{
		to: '/dashboard',
		icon: BsHouse,
		label: 'Dashboard',
		sub: 'Überblick & Tagesplan',
	},
	{
		to: '/leads',
		icon: BsBuilding,
		label: 'Leads',
		sub: 'Leads finden & verwalten',
	},
	{
		to: '/crm',
		icon: BsKanban,
		label: 'CRM',
		sub: 'KI-Vertriebsleiter & Pipeline',
		requires: 'crm.access',
		// When locked, stay clickable and route to the CRM upsell instead of hard-disabling.
		upsellWhenLocked: true,
		children: [
			{ to: '/crm/pipeline', label: 'Pipeline', icon: BsKanban },
			{ to: '/crm/companies', label: 'Unternehmen', icon: BsBuilding },
			{ to: '/crm/activities', label: 'Aktivitäten', icon: BsListCheck },
			{ to: '/crm/calendar', label: 'Kalender', icon: BsCalendarEvent },
			{ to: '/crm/products', label: 'Produkte', icon: BsBox },
			{ to: '/crm/trash', label: 'Papierkorb', icon: BsTrash },
			{ to: '/crm/settings', label: 'Einstellungen', icon: BsGear },
		],
	},
	{
		to: '/contact-lists',
		icon: BsList,
		label: 'Kontaktlisten',
		sub: 'Kontaktlisten verwalten',
	},
	{
		to: '/email-campaigns',
		icon: BsEnvelope,
		label: 'E-Mail Kampagnen',
		sub: 'E-Mail-Sequenzen erstellen',
		requires: 'email.campaigns',
		children: [
			{ to: '/email-campaigns', label: 'Kampagnen', icon: BsEnvelope },
			{ to: '/email-campaigns/templates', label: 'Templates', icon: BsFileText },
		],
	},
	{
		to: '/post-mailing',
		icon: BsEnvelopePaper,
		label: 'Post-Mailing',
		sub: 'Physische Briefe versenden',
		requires: 'postmailing.campaigns',
		children: [
			{ to: '/post-mailing', label: 'Kampagnen', icon: BsEnvelopePaper },
			{ to: '/post-mailing/templates', label: 'Templates', icon: BsFileText },
		],
	},
	{
		to: 'https://support.b2b-hero.com/',
		icon: BsQuestionCircle,
		label: 'Hilfe',
		sub: 'Support & Dokumentation',
		external: true,
	},
	{
		to: '/company-details',
		icon: BsSearch,
		label: 'Unternehmensdetails',
		sub: 'Unternehmen suchen & Details',
		requires: 'companyDetails',
	},
	{
		to: '/map-search',
		icon: BsMap,
		label: 'Kartensuche',
		sub: 'Suche Kontakte mit Karte',
	},
];

// Kept out of `navItems` because visibility hinges on the `isPlatformAdmin` JWT claim
export const adminNavItem = {
	to: '/admin',
	icon: BsShieldLock,
	label: 'Support-Modus',
	sub: 'Konten und Datenqualität',
	children: [
		{ to: '/admin/accounts', label: 'Konten', icon: BsBuilding },
		{ to: '/admin/data-quality/merges', label: 'Dubletten', icon: BsDiagram3 },
		{ to: '/admin/data-quality/shared-hosts', label: 'Geteilte Domains', icon: BsGlobe2 },
		{ to: '/admin/data-quality/companies', label: 'Firmen', icon: BsPencilSquare },
	],
};

/* True when `pathname` is `to` or nested under it (e.g. '/post-mailing' matches '/post-mailing/42'). */
export const pathMatches = (pathname, to) => pathname === to || pathname.startsWith(`${to}/`);

/**
 * Finds the top-level nav item owning the given path. Sub-routes resolve to their parent,
 * so '/crm/companies/42' yields the CRM item. External items are skipped — they never
 * correspond to an in-app route. Admin routes resolve too, so their pages get a header
 * label even though the item only renders for platform admins.
 *
 * @param {string} pathname - Current location pathname.
 * @returns {{label: string, sub?: string}|undefined}
 */
export const resolveNavItem = (pathname) =>
	[...navItems, adminNavItem]
		.filter((item) => !item.external && pathMatches(pathname, item.to))
		.sort((a, b) => b.to.length - a.to.length)[0];

export default navItems;
